import { useCallback, useState } from 'react'

const useInput = ({
  initialValue = '',
  formatter = v => v } = {}
) => {
  const [value, setValue] = useState(() => formatter(initialValue))

  const onChange = useCallback(
    event => {
      const rawValue = event?.target?.value ?? ''
      setValue(formatter(rawValue))
    },
    [formatter]
  )

  const reset = useCallback(() => {
    setValue(formatter(initialValue))
  }, [formatter, initialValue])

  return {
    value,
    setValue,
    onChange,
    reset
  }
}

export default useInput
